import CompanyBranchListEditComponent from "../components/CompanyBranchListEdit";
import useCompanyBranch from "../hooks/useCompanyBranch";

function CompanyBranchListEdit(props) {
  const useCompanyBranchProps = useCompanyBranch(props);
  return <CompanyBranchListEditComponent {...useCompanyBranchProps} />;
}

export default CompanyBranchListEdit;
